var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle2NoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22286,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    stroke: "#2AA663",
    strokeWidth: 0.848056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6701 27.8234V26.3706L22.5243 22.5923C22.8929 22.22 23.2001 21.8894 23.4458 21.6003C23.6916 21.3112 23.8759 21.0311 23.9987 20.76C24.1216 20.489 24.183 20.1999 24.183 19.8927C24.183 19.5422 24.1035 19.2422 23.9445 18.9929C23.7855 18.7399 23.5669 18.5447 23.2886 18.4074C23.0103 18.2701 22.6941 18.2014 22.34 18.2014C21.975 18.2014 21.6551 18.2773 21.3805 18.4291C21.1058 18.5773 20.8926 18.7887 20.7408 19.0633C20.5927 19.338 20.5186 19.665 20.5186 20.0445H18.605C18.605 19.3398 18.7658 18.7272 19.0875 18.2068C19.4091 17.6864 19.8518 17.2835 20.4156 16.998C20.983 16.7125 21.6335 16.5698 22.3671 16.5698C23.1115 16.5698 23.7656 16.7089 24.3294 16.9872C24.8932 17.2654 25.3304 17.6467 25.6412 18.1309C25.9557 18.6152 26.1129 19.1681 26.1129 19.7897C26.1129 20.2053 26.0333 20.6137 25.8743 21.0148C25.7153 21.416 25.4353 21.8605 25.0341 22.3483C24.6366 22.8362 24.0782 23.4271 23.3591 24.1209L21.4455 26.067V26.1429H26.2809V27.8234H18.6701Z",
    fill: "#2AA663"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2NoCheck);
export default __webpack_public_path__ + "static/media/Circle2NoCheck.814d539e6a8ad8c2dcf45b3d11f21a8a.svg";
export { ForwardRef as ReactComponent };